/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantContextResponse } from '../../models/tenant-context-response';

export interface GetTenantContext$Params {
}

export function getTenantContext(http: HttpClient, rootUrl: string, params?: GetTenantContext$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantContextResponse>> {
  const rb = new RequestBuilder(rootUrl, getTenantContext.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantContextResponse>;
    })
  );
}

getTenantContext.PATH = '/tenant/context';
